import { Box, Grid, Tab, Tabs, Typography, useTheme } from '@mui/material';
import { BarChart } from '@mui/x-charts';
import { useState } from 'react';

const truncate = (text, max = 28) => {
  if (!text) return '';
  return text.length > max ? `${text.slice(0, max)}...` : text;
};

const formatMinutes = (minutes = 0) => {
  const total = Number(minutes || 0);
  const hrs = Math.floor(total / 60);
  const mins = Math.floor(total % 60);

  if (hrs <= 0) return `${mins}min`;

  return `${hrs}h${mins > 0 ? ` ${mins}min` : ''}`;
};

const OrdensPendentes = ({ data = [] }) => {
  const theme = useTheme();
  const [view, setView] = useState('quantidade');

  const isTempo = view === 'tempo';

  const chartData = data
    ?.map((item) => ({
      setor: item?.setor || 'SEM SETOR',
      quantidade: Number(item?.quantidade || 0),
      tempo: Number(item?.tempo || 0),
    }))
    ?.sort((a, b) =>
      isTempo ? b.tempo - a.tempo : b.quantidade - a.quantidade
    );

  if (!chartData?.length) return null;

  return (
    <Grid item xs={12} md={6}>
      <Grid item xs={12}>
        <Box gap={2} height="100%" display="flex" flexDirection="column">
          <Typography variant="h5" fontWeight="bold">
            Produção Pendente
          </Typography>
          <Tabs
            value={view}
            textColor="primary"
            indicatorColor="primary"
            onChange={(_, value) => setView(value)}
          >
            <Tab value="quantidade" label="Quantidade" />
            <Tab value="tempo" label="Tempo" />
          </Tabs>
          <Box mt="auto" width="100%">
            <BarChart
              layout="horizontal"
              height={Math.max(chartData.length * 50, 100)}
              margin={{ left: 220, top: 20, right: 20 }}
              series={[
                {
                  data: chartData.map((item) =>
                    isTempo ? item.tempo : item.quantidade
                  ),
                  color: theme.palette.primary.main,
                  valueFormatter: (value) =>
                    isTempo ? formatMinutes(value) : `${value} processos`,
                },
              ]}
              yAxis={[
                {
                  scaleType: 'band',
                  data: chartData.map((item) => truncate(item.setor)),
                  categoryGapRatio: 0.5,
                },
              ]}
              xAxis={[
                {
                  label: isTempo ? 'Tempo previsto' : 'Quantidade de OPs',
                  min: 0,
                  max: isTempo ? 60 : undefined,
                  tickMinStep: isTempo ? 15 : 1,
                  valueFormatter: (value) =>
                    isTempo ? formatMinutes(value) : String(value),
                },
              ]}
            />
          </Box>
        </Box>
      </Grid>
    </Grid>
  );
};

export default OrdensPendentes;
